import * as React from "react";
import { useEffect, useState } from "react";
import {
  AutocompleteInput,
  AutocompleteArrayInput,
  BooleanInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import { FilterInputType, FilterTypes } from "../../../src/Enums/FilterTypes";
import { CustomDatetime } from "../CustomDatetime";
import FilterSelect from "./FilterSelect";
export default function FilterInput(props) {
  const {
    source,
    inputType,
    label,
    optionText,
    optionValue,
    choices,
    filterType,
    filterTypeChangeDisable,
    defValue,
    reference,
    minFilterQuery,
    initValue,
    resettable,
    onChange,
    showFilterSelect = true,
  } = props;
  const [filterOperation, setFilterOperation] = useState<any>();
  const [defaultValue, setDefaultValue] = useState<FilterTypes>();

  const handleChange = value => {
    switch (value) {
      case FilterTypes.Contains:
        setFilterOperation(`${source}__contains`);
        break;
      case FilterTypes.NotContain:
        setFilterOperation(`!${source}.ToString().ToLower().Contains($.ToLower())`);
        break;
      case FilterTypes.Equals:
        setFilterOperation(`${source}__eq`);
        break;
      case FilterTypes.NotEquals:
        setFilterOperation(`${source}__neq`);
        break;
      case FilterTypes.GreaterThan:
        setFilterOperation(`${source}__gt`);
        break;
      case FilterTypes.GreaterThanOrEqual:
        setFilterOperation(`${source}__gte`);
        break;
      case FilterTypes.LessThan:
        setFilterOperation(`${source}__lt`);
        break;
      case FilterTypes.LessThanOrEqual:
        setFilterOperation(`${source}__lte`);
        break;
      case FilterTypes.In:
        setFilterOperation(`${source}__in`);
        break;
      default:
        setFilterOperation(`${source}__contains`);
        break;
    }
  };

  useEffect(() => {
    if (filterType != null) {
      handleChange(filterType);
      setDefaultValue(filterType);
    } else {
      switch (inputType) {
        case FilterInputType.Date:
          setDefaultValue(FilterTypes.GreaterThan);
          handleChange(FilterTypes.GreaterThan);
          break;
        case FilterInputType.Number:
          setDefaultValue(FilterTypes.GreaterThanOrEqual);
          handleChange(FilterTypes.GreaterThanOrEqual);
          break;
        case FilterInputType.Select:
          setDefaultValue(FilterTypes.Equals);
          handleChange(FilterTypes.Equals);
          break;
        case FilterInputType.Reference:
          setDefaultValue(FilterTypes.Equals);
          handleChange(FilterTypes.Equals);
          break;
        case FilterInputType.Bool:
          setDefaultValue(FilterTypes.Equals);
          handleChange(FilterTypes.Equals);
          break;
        case FilterInputType.AutoComplete:
          setDefaultValue(FilterTypes.Equals);
          handleChange(FilterTypes.Equals);
          break;
        case FilterInputType.AutoCompleteArray:
          setDefaultValue(FilterTypes.In);
          handleChange(FilterTypes.In);
          break;
        default:
          setDefaultValue(FilterTypes.Contains);
          handleChange(FilterTypes.Contains);
          break;
      }
    }
  }, []);

  if (!showFilterSelect) {
    return null;
  }
  switch (inputType) {
    case FilterInputType.Text:
      return (
        <TextInput
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Text}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          label={label}
          defaultValue={defValue}
        />
      );
    case FilterInputType.Date:
      return (
        <CustomDatetime
          fullWidth
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Date}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          label={label}
          defaultValue={defValue}
          itemType={"date-local"}
        />
      );
    case FilterInputType.Number:
      return (
        <NumberInput
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Number}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          label={label}
          defaultValue={defValue}
        />
      );
    case FilterInputType.Bool:
      return (
        <BooleanInput
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Bool}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          label={label}
          defaultValue={defValue}
        />
      );
    case FilterInputType.Select:
      return (
        <SelectInput
          resettable={resettable}
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Number}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          emptyText={"Clear"}
          choices={choices}
          optionText={optionText}
          optionValue={optionValue}
          source={filterOperation}
          label={label}
          defaultValue={defValue}
          initialValue={initValue}
          allowEmpty={true}
          onChange={onChange}
        />
      );
    case FilterInputType.Reference: {
      return (
        <ReferenceInput
          resettable
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.Reference}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          reference={reference}
          filterToQuery={searchText => ({ acReg__contains: searchText })}
          enableGetChoices={({ q }) => q && q.length >= minFilterQuery}
        >
          <AutocompleteInput label={label} optionText={optionText} optionValue={optionValue} />
        </ReferenceInput>
      );
    }
    case FilterInputType.AutoComplete: {
      return (
        <AutocompleteInput
          resettable
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.AutoComplete}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          emptyText="Clear"
        />
      );
    }
    case FilterInputType.AutoCompleteArray: {
      if (!choices || choices.length === 0) {
        return null;
      }
      return (
        <AutocompleteArrayInput
          resettable={resettable}
          {...props}
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                Type={FilterInputType.AutoCompleteArray}
                handleChange={handleChange}
                defaultValue={defaultValue}
              />
            ),
          }}
          source={filterOperation}
          label={label}
          choices={choices}
          optionText={optionText}
          optionValue={optionValue}
          defaultValue={defValue}
        />
      );
    }
    default:
      return (
        <TextInput
          InputProps={{
            startAdornment: (
              <FilterSelect
                disabled={filterTypeChangeDisable}
                handleChange={handleChange}
                defaultValue={FilterTypes.Contains}
              />
            ),
          }}
          source={filterOperation}
          label="RefNo"
          defaultValue={defValue}
          alwaysOn
        />
      );
  }
}
